import React from 'react';
import { ISvgIconProps, SvgIcon } from './svg-icon.component';

export const ChevronForwardIcon: React.FC<ISvgIconProps> = (props) => {
    return (
        <SvgIcon size={1}  {...props} viewBox="0 0 6 10" ratio={6 / 10}>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M0.484835 0.234835C0.338388 0.381282 0.338388 0.618718 0.484835 0.765165L4.71967 5L0.484835 9.23483C0.338388 9.38128 0.338388 9.61872 0.484835 9.76517C0.631281 9.91161 0.868719 9.91161 1.01516 9.76517L5.51517 5.26516C5.66161 5.11872 5.66161 4.88128 5.51517 4.73484L1.01516 0.234835C0.868719 0.0883883 0.631281 0.0883883 0.484835 0.234835Z"
                  fill={props.color? props.color: "currentColor"}/>

        </SvgIcon>
    );
}
